import { reportUncaughtException } from 'src/dataLayer/remoteData/rollbar';

window.onerror = () => reportUncaughtException;
